import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import { AutocompleteAPI, Box, ControlLabelCheckBox, FormField, Typography } from "@maysoft/common-component-react";

import Strings from "constants/strings";
import useDataCommon from "hooks/useDataCommon.hook";

import Constants from "constants/index";
import { BooleanInt, Mode, RepeatIssue, ReportStatus } from "constants/enum";
import { IDataDetailAnalysis, IErrorAnalysis } from "commons/interfaces";



export const CardGeneralInformation = ({
    mode,
    dataAnalysis,
    errorAnalysis,
    handleChangeValue,
}: {
    mode: Mode,
    errorAnalysis: IErrorAnalysis;
    dataAnalysis: IDataDetailAnalysis;
    handleChangeValue: (key: string, value: any) => void;
}) => {

    const { getDataReferenceReports } = useDataCommon();

    return (
        <Card sx={{ padding: 3 }}>
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <Typography variant="h6">
                        {Strings.ANALYSIS.GENERAL_INFORMATION}
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={6}>
                    <ControlLabelCheckBox
                        mode={mode}
                        disabled={dataAnalysis.reportStatus == ReportStatus.analyzed}
                        label={Strings.REPORT.REPEAT_ISSUE}
                        value={(dataAnalysis?.repeatIssue !== RepeatIssue.None)}
                        onChangeValue={() => {
                            if (dataAnalysis?.repeatIssue === RepeatIssue.RepeatedUnconfirmed) {
                                handleChangeValue("repeatIssue", RepeatIssue.None);
                            } else {
                                handleChangeValue("repeatIssue", RepeatIssue.RepeatedUnconfirmed);
                            }
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <AutocompleteAPI
                        mode={mode}
                        variant={"outlined"}
                        optionDisabled={[dataAnalysis?.id || ""]}
                        defaultValue={dataAnalysis?.referenceId}
                        errorMessage={errorAnalysis?.referenceId}
                        label={Strings.REPORT.REFERENCE_INCIDENT}
                        placeholder={Strings.REPORT.SELECT_REFERENCE_INCIDENT}
                        required={dataAnalysis?.repeatIssue === RepeatIssue.RepeatedUnconfirmed}
                        disabled={dataAnalysis?.repeatIssue !== RepeatIssue.RepeatedUnconfirmed}
                        dataSelected={dataAnalysis?.referenceId ? [{
                            code: dataAnalysis?.referenceId || "",
                            name: dataAnalysis?.referenceCode || "",
                        }] : []}
                        requestGetApi={{ repeatIssues: [RepeatIssue.None] }}
                        getApi={getDataReferenceReports}
                        onChange={(value) => { }}
                        onChangeItem={(value) => {
                            handleChangeValue("referenceId", value);
                        }}
                    />
                </Grid>
                <Grid item xs={12}>
                    <FormField
                        required
                        multiline
                        mode={mode}
                        minRows={3}
                        maxRows={10}
                        variant={"outlined"}
                        maxLength={Constants.CHAR_MAX_LENGTH.REPORT_DETAIL_DESCRIPTION}
                        label={Strings.ANALYSIS.DETAIL_DESCRIPTION + ` (${Strings.formatString(Strings.MESSAGE.CHAR_MAX_LENGTH, Constants.CHAR_MAX_LENGTH.REPORT_DETAIL_DESCRIPTION)})`}
                        value={dataAnalysis?.detailDescription || ""}
                        errorMessage={errorAnalysis?.detailDescription}
                        placeholder={Strings.ANALYSIS.ENTER_DESCRIPTION}
                        onChangeValue={(value) => {
                            handleChangeValue("detailDescription", value);
                        }}
                    />
                    {dataAnalysis?.rootCause &&
                        <Box pt={1} display={"flex"}>
                            <Typography variant="caption" color="secondary">
                                <pre style={{ fontFamily: "inherit" }}>
                                    {dataAnalysis?.rootCause || ""}
                                </pre>
                            </Typography>
                        </Box>
                    }
                </Grid>

                <Grid item xs={12}>
                    <FormField
                        multiline
                        mode={mode}
                        minRows={3}
                        maxRows={10}
                        variant={"outlined"}
                        maxLength={Constants.CHAR_MAX_LENGTH.REPORT}
                        label={Strings.ANALYSIS.APPLIED_TREATMENT + ` (${Strings.formatString(Strings.MESSAGE.CHAR_MAX_LENGTH, Constants.CHAR_MAX_LENGTH.REPORT)})`}
                        defaultValue={dataAnalysis?.appliedTreatment}
                        errorMessage={errorAnalysis?.appliedTreatment}
                        placeholder={Strings.ANALYSIS.ENTER_DESCRIPTION}
                        onBlur={(value) => {
                            handleChangeValue("appliedTreatment", value);
                        }}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormField
                        multiline
                        mode={mode}
                        minRows={3}
                        maxRows={10}
                        variant={"outlined"}
                        maxLength={Constants.CHAR_MAX_LENGTH.REPORT}
                        label={Strings.ANALYSIS.RECOVER_ACTION + ` (${Strings.formatString(Strings.MESSAGE.CHAR_MAX_LENGTH, Constants.CHAR_MAX_LENGTH.REPORT)})`}
                        defaultValue={dataAnalysis?.recoverAction}
                        errorMessage={errorAnalysis?.recoverAction}
                        placeholder={Strings.ANALYSIS.ENTER_DESCRIPTION}
                        onBlur={(value) => {
                            handleChangeValue("recoverAction", value);
                        }}
                    />
                </Grid>

                <Grid item xs={12} sm={6}>
                    <FormField
                        multiline
                        mode={mode}
                        minRows={3}
                        maxRows={10}
                        variant={"outlined"}
                        maxLength={Constants.CHAR_MAX_LENGTH.REPORT}
                        label={Strings.ANALYSIS.SUGGESTED_SOLUTION + ` (${Strings.formatString(Strings.MESSAGE.CHAR_MAX_LENGTH, Constants.CHAR_MAX_LENGTH.REPORT)})`}
                        placeholder={Strings.ANALYSIS.ENTER_SUGGEST}
                        defaultValue={dataAnalysis?.suggestedSolution}
                        errorMessage={errorAnalysis?.suggestedSolution}
                        onBlur={(value) => {
                            handleChangeValue("suggestedSolution", value);
                        }}
                    />
                </Grid>
            </Grid>
        </Card>
    );
};

export default CardGeneralInformation;
